import React, { useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
  Switch,
  Tooltip,
  Autocomplete,
  TextField
} from "@mui/material";
import axios from "axios";
import { toast } from "react-toastify";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import SweetAlertModal from "../../../components/SweetAlertModal/SweetAlertModal";
import Cancel from "./../../../../assets/icons/close.png";

function EditSectionKitchen({combinedSection, onHandleAddItem,kitchens,getKitchens }) {
  const [sections, setSections] = useState([]);
  const [initialSections, setInitialSections] = useState([]);
  const [openCloseConfirmationModal, setOpenCloseConfirmationModal] = useState(false);
  const apiAddress = process.env.REACT_APP_SECRET;
  console.log(combinedSection)
  console.log(kitchens)
//   useEffect(() => {
//     if (combinedSection) {
//       const initialData = combinedSection.map((section) => ({
//         id: section.id,
//         sectonName: section.sectonName,
//         isDeliverableCheck: section.restaurantIsDelivery ? section.isDelivery : false,
//         isCollectionCheck: section.restaurantIsDelivery ? section.isCollectionOnly : false,
//         restaurantIsDelivery: section.restaurantIsDelivery || false,
//         menuTypeName: section.menuTypeName || "", // Store menuTypeName for validation
//       }));

//       setSections(initialData);
//       setInitialSections(initialData); // Store initial values to detect changes
//     }
//   }, [combinedSection]);

  // Check if there are any unsaved changes


const [selections, setSelections] = useState({});

useEffect(() => {
  if (!kitchens[0]?.kitchens || !combinedSection) return;

  const initialSelections = combinedSection.reduce((acc, section) => {

      const restaurantKitchens = kitchens.find(k => k.id === section.restaurantId)?.kitchens || [];

      const defaultValue = restaurantKitchens.find(k => k.id === section.kitchenId);

      acc[section.id] = defaultValue || null;
      return acc;
  }, {});

  setSelections(initialSelections);
}, [kitchens, combinedSection]);

const handleSelectionChange = (menuId, newValue) => {
    setSelections(prev => ({
        ...prev,
        [menuId]: newValue
    }));
};
useEffect(() => {
getKitchens(selections)
console.log(selections)
}, [selections]);

  return (
    <div>
        {combinedSection.map((section, index) => {
          const filteredKitchens = kitchens.find(kitchen => kitchen.id === section.restaurantId)?.kitchens || [];
          return (
            <Grid container key={section.id} spacing={2} sx={{ padding: "0.5rem", marginBottom: "1rem" }}>
              <Grid item xs={12}>
                <Typography fontSize={16} sx={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
                  <h6>{section.sectonName}</h6>
                </Typography>
                <Autocomplete
                    id={`single-select-${section.id}`}
                    options={filteredKitchens}
                    getOptionLabel={(option) => option.kitchenName}
                    value={selections[section.id] || null}
                    onChange={(event, newValue) => handleSelectionChange(section.id, newValue)}
                    renderInput={(params) => <TextField {...params} label="Select Option" variant="outlined" />}
                    sx={{ width: '100%', paddingY: '.5rem' }}
                />
              </Grid>
            </Grid>
          );
        })}
</div>
  );
}

export default EditSectionKitchen;
